import { render, staticRenderFns } from "./NormalSearchNav485.vue?vue&type=template&id=632df294&scoped=true&"
import script from "./NormalSearchNav485.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav485.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632df294",
  null
  
)

export default component.exports